"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerEvaluator = exports.interpolate = exports.Evaluator = exports.DefaultEvaluator = void 0;
const lodash_1 = __importDefault(require("lodash"));
const string_hash_1 = __importDefault(require("string-hash"));
const core_1 = require("@formio/core");
class DefaultEvaluator extends core_1.DefaultEvaluator {
    constructor() {
        super(...arguments);
        this.cache = {};
        this.protectedEval = false;
    }
    template(template, hash) {
        hash = hash || (0, string_hash_1.default)(template);
        if (this.cache[hash]) {
            return this.cache[hash];
        }
        try {
            // Ensure we handle copied templates from the ejs files.
            template = template.replace(/ctx\./g, '');
            return (this.cache[hash] = lodash_1.default.template(template, this.templateSettings));
        }
        catch (err) {
            console.warn('Error while processing template', err, template);
        }
    }
    interpolate(rawTemplate, data, _options) {
        // Ensure reverse compatability.
        const options = lodash_1.default.isObject(_options) ? _options : { noeval: _options };
        if (typeof rawTemplate === 'function') {
            try {
                return rawTemplate(data);
            }
            catch (err) {
                console.warn('Error interpolating template', err, data);
                return err.message;
            }
        }
        rawTemplate = String(rawTemplate);
        let template;
        if (this.noeval || options.noeval) {
            return this.interpolateString(rawTemplate, data, _options);
        }
        else {
            template = this.template(rawTemplate);
        }
        if (typeof template === 'function') {
            try {
                return template(data);
            }
            catch (err) {
                console.warn('Error interpolating template', err, rawTemplate, data);
                return err.message;
            }
        }
        return template;
    }
}
exports.DefaultEvaluator = DefaultEvaluator;
exports.Evaluator = new DefaultEvaluator();
// preserve the standalone interpolate function for backwards compatibility
/**
 * For backwards compatibility we a standalone interpolate function. This merely calls the
 * global mutable Evaluator instance's interpolate function.
 * @param  {...any} args - interpolate arguments, typically "rawTemplate", "data", and "options"
 * @returns {any} the interpolation result.
 */
function interpolate(...args) {
    return exports.Evaluator.interpolate(...args);
}
exports.interpolate = interpolate;
/**
 * Set the evaluator to use for evaluating expressions.
 * @param {CoreEvaluator} override - The new evaluator instance to use.
 * @returns {void}
 */
function registerEvaluator(override) {
    exports.Evaluator = override;
}
exports.registerEvaluator = registerEvaluator;
